import axios from 'axios';
import axiosRetry from 'axios-retry';
import { authService } from '@/core/auth/export';

axios.defaults.baseURL = process.env.REACT_APP_SELECT_HOST as string;

axios.interceptors.request.clear();
axios.interceptors.request.use(async value => {
  value.headers['Authorization'] = `Bearer ${(await authService.getAccessToken())?.access_token}`;
  return value;
});

axiosRetry(axios, {
  retries: 5, // number of retries
  retryDelay: retryCount => {
    console.log(`retry attempt: ${retryCount}`);
    return retryCount * 1000; // 500ms * retry count
  },
  retryCondition: error => {
    // if retry condition is not specified, by default idempotent requests are retried
    return error?.status ? error.status >= 500 : false;
  },
  onMaxRetryTimesExceeded: (error, retryCount) => {
    authService.notifyApiError('Retries exceeded');
  },
});
